/** @format */

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, inject, input } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';
import { HmfCarouselComponent } from '@dsg-tech/homefield-angular-cdk';
import { ProTipsArticle } from './pro-tips-article.interface';
import { ProTipsDataService } from './pro-tips-data.service';

@Component({
	selector: 'shared-component-pro-tips',
	templateUrl: './pro-tips.component.html',
	styleUrls: ['./pro-tips.component.scss'],
	imports: [CommonModule, HmfCarouselComponent],
	providers: [ProTipsDataService]
})
export class ProTipsComponent implements OnInit {
	category = input<string>('');

	articleData: ProTipsArticle[] = [];
	headerSvg = 'assets/image/dsg/Dicks_ProTips.svg';
	altSvgText = 'DSG PRO TIPS';
	platformId = inject(PLATFORM_ID);
	isBrowser = isPlatformBrowser(this.platformId);

	constructor(
		private readonly proTipsDataService: ProTipsDataService,
		private readonly chain: Chain
	) {}

	ngOnInit(): void {
		const chainId = this.chain.chainIdentifierAbbr;
		this.proTipsDataService.getProTipsData$(this.category(), chainId).subscribe((res) => {
			if (res) {
				this.articleData = res;
			}
		});

		if (chainId === 'gg' || chainId === 'pl') {
			this.headerSvg = `assets/image/${chainId}/${chainId.toUpperCase()}_ProTips.svg`;
			this.altSvgText = `${chainId.toUpperCase()} PRO TIPS`;
		}
	}
}
